import { useQuery } from "convex/react";
import { api } from "convex/_generated/api";
import type { FunctionReturnType } from "convex/server";
import { useAdminMode } from "../contexts/AdminModeContext";

const PREVIEW_USERS = {
  guest: null,
  dancer: { accountType: "dancer" as const, verificationStatus: "unverified" as const },
  organizer: { accountType: "organizer" as const, verificationStatus: "unverified" as const },
  studio: { accountType: "studio" as const, verificationStatus: "unverified" as const, studioName: "Preview Studio" },
  volunteer: { accountType: "dancer" as const, verificationStatus: "verified" as const },
  moderator: { accountType: "dancer" as const, verificationStatus: "verified" as const },
};

/** What `users.getCurrentUser` resolves to once it has loaded. */
type CurrentUser = FunctionReturnType<typeof api.users.getCurrentUser>;

export function useCurrentUser() {
  const user = useQuery(api.users.getCurrentUser);
  const { isPreviewMode, previewRole } = useAdminMode();

  if (isPreviewMode && previewRole) {
    const fakeUser = PREVIEW_USERS[previewRole];
    // Preview users carry only the fields the UI branches on, but callers
    // should still see the real user type rather than `any`.
    return {
      user: fakeUser as unknown as CurrentUser,
      isLoading: false,
      isLoggedIn: fakeUser !== null,
    };
  }

  return {
    user,
    isLoading: user === undefined,
    isLoggedIn: user !== null && user !== undefined,
  };
}
